/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h } from './index-ef0fa435.js';
import { c as createModal } from './modal-controller-964badac.js';
import './helpers-4516ecbe.js';
import './theme-d6db8abf.js';

const areaCss = "slot-fb[hidden],slot[hidden]{display:initial !important}.details{padding:3rem 0 0 0}.details lar-button-group{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.actions{min-height:60px}lar-list-item{background-color:var(--lar-background-color-step-100, #1a1a1a) !important;color:var(--lar-text-color, #fff) !important}.spacer{margin-top:1.5rem;margin-bottom:1.5rem}.circle{background-color:var(--lar-background-color-step-200, #333333) !important;border-radius:50%;display:inline-block;padding:0.5rem;width:2rem;height:2rem;margin-right:1rem}.circle lar-icon{display:block;width:100%;height:100%}.zone-list h4{margin:0;padding:0}.zone-list h4 lar-badge{margin-top:0.2rem;margin-right:0.3rem;font-weight:normal}.zone-selectors{text-align:center;margin-bottom:1rem}.zone-selectors lar-button{margin:0.2rem}.zone-list lar-badge{margin-top:0.3rem}lar-button.zone-group{--lar-button-font-size-small:.95rem;--lar-button-padding-top-small:.4rem;--lar-button-padding-bottom-small:.4rem;--lar-button-padding-left-small:.4rem;--lar-button-padding-right-small:.4rem}.center{text-align:center}";

const AreaContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.arm = createEvent(this, "arm", 7);
    this.disarm = createEvent(this, "disarm", 7);
    this.output = createEvent(this, "output", 7);
    this.color = undefined;
    this.colorModal = undefined;
    this.zones = undefined;
    this.troubles = undefined;
    this.armed = false;
    this.zoneopened = false;
    this.hastroubles = false;
    this.icon = undefined;
    this.alarm = false;
    this.loading = true;
  }
  async showModal(title, subTitle, component) {
    this.modal = await createModal({
      mainTitle: title,
      subTitle,
      color: this.colorModal || this.color,
      animation: 'bottom',
      iconSmall: this.loading ? 'loading' : '',
      colorHeaderInputs: this.color,
      icon: this.icon,
      headerSize: 'small',
      onLarmodaldiddismiss: () => {
        this.modal = undefined;
        this.modalComponent = undefined;
      },
      component,
      componentProps: {
        zones: this.zones,
        troubles: this.troubles,
        onOutput: (evt) => this.output.emit(evt.detail),
        color: this.color,
      }
    });
    await this.modal.present();
    this.modalComponent = await this.modal.getComponent();
  }
  async disconnectedCallback() {
    var _a;
    return (_a = this.modal) === null || _a === void 0 ? void 0 : _a.dismiss();
  }
  render() {
    if (this.modalComponent) {
      this.modalComponent.element.setAttribute('zones', this.zones);
      this.modalComponent.element.setAttribute('troubles', this.troubles);
      this.modalComponent.element.setAttribute('color', this.color);
    }
    return [
      h("div", { class: "actions" }, (this.armed || this.alarm)
        ?
          h("lar-button", { onClick: () => this.disarm.emit(), color: this.color, disabled: this.loading }, h("lar-icon", { icon: "unlock" }), " ", h("lar-translate", { t: "area.disarm" }))
        :
          h("lar-button-group", null, h("lar-button", { disabled: this.zoneopened || this.loading, onClick: () => this.hastroubles ? this.showModal('area.overrideAndBypass', 'area.selectZonesToBypass', 'lar-area-bypass') : this.arm.emit(), color: this.color }, h("lar-icon", { icon: "lock" }), " ", h("lar-translate", { t: "area.arm" })), h("lar-button", { disabled: this.loading, onClick: () => this.showModal('area.partialarm', 'area.selectZonesToBypass', 'lar-area-bypass'), color: this.color === 'dark' ? 'light' : 'dark' }, h("lar-icon", { icon: "halflock" }), " ", h("lar-translate", { t: "area.partialarm" })))),
      h("div", { class: "details" }, h("lar-button-group", null, this.hastroubles
        &&
          h("lar-button", { color: "warning", size: "small", expand: "block", outline: true, onClick: () => this.showModal('area.troubles', '', 'lar-area-troubles') }, h("lar-icon", { icon: "warning" }), "\u00A0", h("lar-translate", { t: "area.troubles" })), h("lar-button", { color: this.color, size: "small", expand: "block", outline: true, onClick: () => this.showModal('area.zonemonitor', '', 'lar-area-zones') }, h("lar-translate", { t: "area.zonemonitor" }), "\u00A0", this.zoneopened
        ?
          h("lar-icon", { icon: "unlock" })
        :
          h("lar-icon", { icon: "lock" }))))
    ];
  }
};
AreaContent.style = areaCss;

export { AreaContent as lar_area_content };

//# sourceMappingURL=lar-area-content.entry.js.map